/**
 * @generated SignedSource<<39db3f5499854b65d83e067f258c6b4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Envs",
    "kind": "LinkedField",
    "name": "envs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "envs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QEnvsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "QEnvsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fdeaa079556c7891c90a5f0082d0427d",
    "id": null,
    "metadata": {},
    "name": "QEnvsQuery",
    "operationKind": "query",
    "text": "query QEnvsQuery {\n  envs {\n    envs\n  }\n}\n"
  }
};
})();

node.hash = "2088da6a2fdcfff77335ab0165d5aef9";

export default node;
